import { authHeaders } from './auth';

const WORKER_URL = process.env.REACT_APP_WORKER_URL || '';

// key che iniziano con 'group:' vanno all'endpoint condiviso
function endpoint(key) {
  if (key.startsWith('group:')) return `${WORKER_URL}/api/storage/shared/${key.replace('group:','')}`;
  return `${WORKER_URL}/api/storage/${key}`;
}

// Compatibilità Safari < 16: AbortSignal.timeout non disponibile
function timeoutSignal(ms) {
  if (typeof AbortSignal.timeout === 'function') return AbortSignal.timeout(ms);
  const ctrl = new AbortController();
  setTimeout(() => ctrl.abort(), ms);
  return ctrl.signal;
}

export async function kvGet(key) {
  if (!WORKER_URL) return null;
  try {
    const r = await fetch(endpoint(key), {
      headers:     authHeaders(),
      credentials: 'include',
      signal:      timeoutSignal(5000),
    });
    if (!r.ok) return null;
    const d = await r.json();
    return d.value;
  } catch { return null; }
}

export async function kvPut(key, value) {
  if (!WORKER_URL) return false;
  try {
    const r = await fetch(endpoint(key), {
      method:      'PUT',
      headers:     { 'Content-Type': 'application/json', ...authHeaders() },
      credentials: 'include',
      body:        JSON.stringify({ value }),
    });
    return r.ok;
  } catch { return false; }
}

export async function kvDelete(key) {
  if (!WORKER_URL) return false;
  try {
    const r = await fetch(endpoint(key), {
      method:      'DELETE',
      headers:     { 'Content-Type': 'application/json', ...authHeaders() },
      credentials: 'include',
    });
    return r.ok;
  } catch { return false; }
}

// Subscribe to shared key updates via Server-Sent Events (SSE)
// SA-003: chiede prima un token stream temporaneo (TTL 60s) via POST autenticato.
// EventSource usa ?st=<token> — il JWT principale non finisce mai in URL o log.
// Se SSE muore dopo la scadenza del token, il polling ogni 15s mantiene la sync.
export function kvSubscribe(key, onMessage) {
  if (!WORKER_URL) return () => {};
  if (!key.startsWith('group:')) return () => {};
  const subKey = key.replace('group:', '');

  let es = null;
  let closed = false;

  (async () => {
    try {
      const r = await fetch(`${WORKER_URL}/api/auth/stream-token`, {
        method:      'POST',
        headers:     authHeaders(),
        credentials: 'include',
        signal:      timeoutSignal(5000),
      });
      if (!r.ok || closed) return;
      const { streamToken } = await r.json();
      if (!streamToken || closed) return;
      const url = `${WORKER_URL}/api/stream/shared/${encodeURIComponent(subKey)}?st=${encodeURIComponent(streamToken)}`;
      es = new EventSource(url);
      es.onmessage = (e) => {
        try { const d = JSON.parse(e.data); onMessage(d); } catch {}
      };
      // Se SSE fallisce (token scaduto o rete), chiude — polling ogni 15s mantiene sync
      es.onerror = () => { if (es) { es.close(); es = null; } };
    } catch {}
  })();

  return () => {
    closed = true;
    if (es) { es.close(); es = null; }
  };
}
